<script>
import { mapActions } from 'vuex'
import { list, get, del } from '@/api/empresa'

// Colunas
import columns from './colunas'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  async mounted () {
    this.modalAdd = await this.newModal({
      component: 'app-empresa-edit',
      width: 920,
      onSave: async (data) => {
        if (data.nome_empresa) this.refresh(data.nome_empresa)
        else this.$refs.completeGrid.refreshList()
      },
      onCancel: () => {
        this.$refs.completeGrid.focoPesquisa()
      }
    })
  },
  data () {
    return {
      tela: 'empresa',
      acoes: {
        add: 'empresa_incluir',
        edit: 'empresa_editar',
        delete: 'empresa_excluir'
      },
      modalAdd: false,
      columns: columns,
      indices: [
        { value: 'cnpj', label: 'CNPJ' },
        { value: 'nome_empresa', label: 'Nome' },
        { value: 'nome_fantasia', label: 'Fantasia' },
        { value: 'responsavel', label: 'Responsável' }
      ]
    }
  },
  methods: {
    ...mapActions({
      newModal: 'modal/new',
      openModal: 'modal/open',
      confirmarModal: 'modal/confirmar',
      toaster: 'modal/toaster'
    }),
    refresh (data) {
      if (this.mode === 'tab') this.$refs.completeGrid.refreshList()
      else if (this.mode === 'modal') this.$refs.completeGrid.changeBusca(data)
    },
    async getList (filtros) {
      let data = await list(filtros)
      return {
        data: data.data,
        totalCount: data.total
      }
    },
    async novo () {
      let data = {
        nome_empresa: null,
        cidade: {}
      }
      if (this.mode === 'modal') this.openModal({ modal: this.modalAdd, data })
      else this.$emit('onEdit', data)
    },
    async editar (row) {
      let data = await get(row.data.id)
      if (this.mode === 'modal') this.openModal({ modal: this.modalAdd, data })
      else this.$emit('onEdit', data)
    },
    async excluir (row) {
      this.confirmarModal({
        msg: 'Deseja realmente excluir essa empresa?',
        onConfirm: async () => {
          await del(row.data.id)
          this.toaster({ message: 'Excluido com sucesso!', color: 'success' })
          this.$refs.completeGrid.refreshList()
        }
      })
    },
    async selecionar (selecionado) {
      if (selecionado.id) this.$emit('save', selecionado)
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Listar Empresa" @onClose="() => $emit('cancel')">
    <ui-complete-grid
      ref="completeGrid"
      :tela="tela"
      :columns="columns"
      :indices="indices"
      :selection="mode === 'modal'"
      :datasource="getList"
      :acoes="acoes"
      @onSelect="selecionar"
      @onCancel="$emit('cancel')"
      @onAdd="novo"
      @onEdit="editar"
      @onDelete="excluir" />
  </ui-layout-modal>
</template>
